const i9AdminKey = ['admin', 'i9'] as const

export const i9AdminKeys = {
  all: i9AdminKey,
  workAuthorizationExpirationReport: () =>
    [...i9AdminKey, 'workAuthorizationExpirationReport'] as const,
}
